import { render } from "./PreviewLocale.vue?vue&type=template&id=47d1c7f2"
import script from "./PreviewLocale.vue?vue&type=script&lang=js"
export * from "./PreviewLocale.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__